import React from 'react';

import S from 'constants/string.const';

const NotificationAlert = ({ closeNotification, id, messageText, showCloseBtn, type }) => (
  <div data-bem="NotificationAlert" key={id} className={`alert  ${type} animated zoomIn`}>
    <span data-bem="NotificationAlert__message-text"> {messageText}</span>
    {showCloseBtn && (
      <button data-bem="NotificationAlert__close-button" type="button" onClick={() => void closeNotification(id)}>
        {S.markX}
      </button>
    )}
  </div>
);

export default NotificationAlert;
